export default __webpack_public_path__ + "media/invoice/stamp-paid-373448c5.png";